export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200 py-8 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-6 md:mb-8">
          <div className="col-span-1 md:col-span-2">
            <a href="https://www.mustsafe.co.kr/" target="_blank" rel="noopener noreferrer">
              <img 
                src="https://static.readdy.ai/image/f2d4f0b55ceaa6c07b19f5a03d25a420/3fad4718bb9782d32326554ad714f614.png" 
                alt="중대안전보건예방협회" 
                className="h-10 md:h-12 w-auto mb-3 md:mb-4 cursor-pointer"
              />
            </a>
            <div className="text-slate-600 text-xs md:text-sm leading-relaxed mb-3 md:mb-4">
              <p className="mb-2">
                <span className="font-bold">사단법인 중대안전보건예방협회</span> | 협회장 : 김기태 | 개인정보보호책임자 : 박대근 | Email : mustsafe2@gmail.com
              </p>
              <p>
                사업자등록번호 : 788-82-00538 | Fax : 02-857-3309 | 주소 : (우) 08507 서울 금천구 가산디지털1로 168 B동 910호
              </p>
            </div>
          </div>

          <div className="text-left md:text-right">
            <h4 className="font-bold text-slate-900 mb-3 md:mb-4 text-sm md:text-base">빠른 링크</h4>
            <ul className="space-y-1.5 md:space-y-2">
              <li>
                <a href="#services" className="text-slate-600 hover:text-teal-600 text-xs md:text-sm transition-colors cursor-pointer">
                  서비스 소개
                </a>
              </li>
              <li>
                <a href="#process" className="text-slate-600 hover:text-teal-600 text-xs md:text-sm transition-colors cursor-pointer">
                  진행 절차
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-slate-600 hover:text-teal-600 text-xs md:text-sm transition-colors cursor-pointer">
                  고객 후기
                </a>
              </li>
              <li>
                <a href="#faq" className="text-slate-600 hover:text-teal-600 text-xs md:text-sm transition-colors cursor-pointer">
                  자주 묻는 질문
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-0">
          <p className="text-slate-500 text-xs md:text-sm text-center md:text-left">
            © 2024 중대안전보건예방협회. All rights reserved.
          </p>
          <div className="flex items-center space-x-4">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-teal-600 text-xs md:text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
